// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"4336f32c","453":"e07c6c4e","516":"b72577e1"}[chunkId] + ".chunk.js";
};